<script>
export default {
  name: 'SecondaryLink',
  props: ['link', 'order', 'tabTrap']
}
</script>

<template>
  <a
    class="kb-burger-menu__link"
    :href="link.href"
    :target="link.target"
    @keydown.tab="tabTrap"
  >
    {{ link.text }}
    <div class="kb-ui-icon kb-ui-icon--ui-link"></div>
  </a>
</template>
